import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { routes } from "./app.routes";

const isIframe = window !== window.parent && !window.opener;
const initialNavigation = !isIframe ? 'enabledNonBlocking' : 'disabled';
const scrollPositionRestoration = 'enabled'; // Scrollerà automaticamente verso l'alto
const anchorScrolling = 'enabled'; // Abilita lo scroll verso gli anchor


@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    {
      initialNavigation,
      scrollPositionRestoration,
      anchorScrolling
    }
  )],
  exports: [RouterModule],
})
export class AppRoutingModule { }
